import { Clock, Play, Trash2 } from "lucide-react";
import { Money } from "@ds/ui/Money";
import { Button } from "@ds/ui/Button";
import { formatQty } from "@ds/lib/format";
import { cn } from "@ds/lib/utils";

/**
 * HoldListItem — satu transaksi ditahan (rfc-006 §4). Glanceable: label,
 * jumlah item, total, waktu. Aksi lanjut/hapus. Bukan card melayang — baris
 * dengan border penuh (State Shadow Rule).
 */
export interface HoldListItemProps {
  label: string;
  itemCount: number;
  total: number;
  /** Sudah diformat, mis. "10:24". */
  time: string;
  onResume?: () => void;
  onDelete?: () => void;
  className?: string;
}

export function HoldListItem({
  label,
  itemCount,
  total,
  time,
  onResume,
  onDelete,
  className,
}: HoldListItemProps) {
  return (
    <div
      className={cn(
        "flex items-center gap-3 border-b border-border px-3 py-3 last:border-0 hover:bg-faint/50 transition-colors",
        className,
      )}
    >
      <div className="min-w-0 flex-1">
        <div className="truncate font-medium text-ink">{label}</div>
        <div className="mt-0.5 flex items-center gap-2 text-[0.8125rem] text-muted">
          <span className="inline-flex items-center gap-1">
            <Clock className="size-3.5" aria-hidden />
            {time}
          </span>
          <span aria-hidden>·</span>
          <span className="tabular-nums">{formatQty(itemCount)} item</span>
        </div>
      </div>
      <Money value={total} size="sm" className="shrink-0" />
      <div className="flex shrink-0 items-center gap-1">
        {onResume && (
          <Button
            size="icon"
            variant="ghost"
            onClick={onResume}
            aria-label={`Lanjutkan ${label}`}
          >
            <Play className="size-4" aria-hidden />
          </Button>
        )}
        {onDelete && (
          <Button
            size="icon"
            variant="ghost"
            onClick={onDelete}
            aria-label={`Hapus ${label}`}
            className="text-muted hover:text-danger"
          >
            <Trash2 className="size-4" aria-hidden />
          </Button>
        )}
      </div>
    </div>
  );
}
